export const getParsedLoanItems = (devices: string[]) => {
	return devices
		.filter((device) => device.includes("|"))
		.map((num) => {
			return {
				name: num.split("|")[0],
				serial_id: num.split("|")[1],
			};
		});
};
